import React from 'react';

import Button from 'components/shared/Button';

export type SubcatalogButtonProps = {
  title: string;
  id: number;
  imageUrl: string;
  isSelected: boolean;
  onClick: () => void;
  hasCustomArrangementNotice: boolean;
  hasTooltip: boolean;
  openTooltipModal: (id: string) => void;
};

function SubcatalogButton({
  title,
  id,
  imageUrl,
  isSelected,
  onClick,
  hasTooltip,
  openTooltipModal,
  hasCustomArrangementNotice,
}: SubcatalogButtonProps) {
  const subcatalogButtonId = `subcatalog-button-${id}`;

  return (
    <div className="subcatalog-buttons-tooltip">
      <button
        id={subcatalogButtonId}
        onClick={onClick}
        className={`subcatalog-button ${isSelected ? 'selected' : ''}`}
      >
        <div className="subcatalog-button-heading">
          <img src={imageUrl} width="100" height="75" alt={title} />
          <div className="subcatalog-button-title">
            {title}
            {hasCustomArrangementNotice && (
              <span className="arrangement-notice">
                This product is not available with your custom arrangement
              </span>
            )}
          </div>
        </div>
      </button>
      {hasTooltip && (
        <Button
          type="icon"
          icon="info-circle"
          a11yText="Learn More"
          appearance="light"
          className="tooltip-button"
          onClick={() => openTooltipModal(subcatalogButtonId)}
        />
      )}
    </div>
  );
}

export default SubcatalogButton;
